<template>
  <main class="products">
    <transition-group
      class="flex__container"
      tag="div"
      name="appearing"
      @enter="addDelay"
      @after-enter="removeDelay"
    >
      <div
        v-for="(product, index) in $store.getters['Products/get']"
        :key="index"
        :data-index="index"
        class="product"
        @click.stop="productClick(product)"
      >
          <figure class="product__picture">
            <img
              class="picture picture--texture"
              :src="`${$api.baseURL}/images/texture/${product.featuredVariant}.png`"
            />
            <img
              :src="$api.baseURL + '/images/packshot/' + product.featuredVariant +'.png'"
              class="picture picture--packshot"
            />
          </figure>

          <div :class="`product__info ${getProductStatus(product)}`">
            <div class="product__name">{{product.name[$store.getters['Langs/lang']]}}</div>
            <div class="out-of-stock" v-if="isElectron && (getProductStatus(product) !== 'available' || product.qty === 0)" >{{$t('outofstock')}}</div>
          </div>

      </div>
    </transition-group>
  </main>
</template>
<script>
import Products from '@/components/mixins/Products'
import SDK from '@/components/mixins/SDK'
export default {
  name: 'products',
  mixins: [Products, SDK],
  methods: {
    productClick (product) {
      console.log(`USER: ${product.name['en-US']} clicked`)
      if (product.variants.length > 1) {
        console.log(`PRODUCTS: ${product.name['en-US']} has ${product.variants.length} variants`)
        // if (this.$store.getters['SDK/getStatus']) this.$router.push({ path: `/tryon/${product.featuredVariant}` })
        if (this.$store.getters['SDK/getStatus'] && this.$store.getters['SDK/eanExists'](product.featuredVariant)) {
          this.$router.push({ path: `/preview/${product.featuredVariant}` })
        } else {
          this.$router.push({ path: `/products/${product.featuredVariant}` })
        }
      } else {
        if (!this.isElectron) {
          this.$router.push({ path: `/products/${product.featuredVariant}` })
        }
        console.log(`PRODUCTS: ${product.name['en-US']} has ${product.variants.length} variant`)
        if (this.getProductStatus(product) === 'available') this.$router.push({ path: `/dispenses/${product.featuredVariant}` })
        else {
          console.log(`PRODUCTS: ${product.name['en-US']} OUT OF STOCK`)
        }
      }
    },

    addDelay (el) {
      const DELAY = 100
      const { index } = el.dataset
      el.style['transition-delay'] = `${750 + index * DELAY}ms`
    },

    removeDelay (el) {
      el.style = {}
    },

    getProductStatus (p) {
      const featuredVariant = p.variants.find(v => {
        return v.eanupc === p.featuredVariant
      })
      return featuredVariant.status
    }

  },
  async mounted () {
    this.initModiface()
    await this.$nextTick(() => {
      this.initProducts()
    })
  },
  async beforeCreated () {
    // check Modiface
    this.checkStatus()
    await this.$nextTick(() => {
      console.log(`PRODUCTS PAGE: UPDATE DB`)
      this.updateProducts()
    })
  }
}
</script>
<style scoped lang="scss">
@import '../../style/css/screens.scss';

.products {
  display: flex;
  justify-content: center;
  align-items: center;

  .flex__container {
    flex: 0 1 90%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;

    @media screen and (max-width: $handheld) {
      flex-basis: 95%;
    }

    @media screen and (orientation: landscape) and (max-height: $handheld) {
      flex-basis: 95%;
    }
  }
}

.product {
  flex: 0 1 40%;
  min-width: 175px;
  display: grid;
  grid-gap: 10px;
  grid-template-rows: minmax(61.8%, 2fr) .5fr;
  grid-template-areas: "picture" "info";
  align-items: baseline;

  @media screen and (min-width: $desktop) {
    flex: 0 1 25%;
  }

  @media screen and (max-width: $handheld) {
    min-width: 140px;
    flex: 0 1 17%;
  }
  @media screen and (orientation: landscape) and (max-height: $handheld) {
    min-width: 125px;
    flex: 0 1 17%;
  }

  &__picture {
    grid-area: picture;
    width: 100%;
    position: relative;
  }

  &__info {
    grid-area: info;
    text-align: center;

    & > *:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  &__name {
    font-size: 20px;

    @media screen and (max-width: $handheld) {
      font-size: 17px;
    }
    @media screen and (orientation: landscape) and (max-height: $handheld) {
      font-size: 17px;
    }
  }
}

.out-of-stock {
  font-weight: 800;
  font-size: 22px;
}

.picture {
  &#{&}--texture {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    transform: rotate(45deg);
  }
}

.appearing {
  &-enter, &-leave-to, &-appear {
    opacity: 0;
  }

  &-enter-active, &-appear-active {
    transition: opacity .3s ease-out;
  }
}

</style>
